<script lang="ts">
import { AppFormatNumberComponent } from "./app-format-number.ts";
export default AppFormatNumberComponent;
</script>

<template>
    {{ formattedValue }}
</template>
